import React, { useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Box, Container, Stack } from "@mui/material";
import { MenuItemEnum } from "@/utils/utils";
import MainNavigation from "@/components/MainNavigation/MainNavigation";
import { ShepTab, ShepTabs } from "@/components/GenericComponents/ShepTab";
import ConnectionHome from "./ConnectionHome";
import CustomDatePicker from "@/components/CustomDatePicker/CustomDatePicker";
import {
  setTabSelectionsIntegration,
  selectTabSelectionsIntegration,
} from "@/features/connections/integrationSlice";
import EndpointHome from "./EndpointHome";
import _ from "lodash";
import "./integrations.css";

import FileManager from "./FileManagerHome";
import {
  loadDateFilter,
  selectIntegrationDateFilter,
  setIntegrationDateFilter,
} from "@/features/dateFilterSlice";
import EmailManager from "./EmailManager/EmailManagerHome";

const integrationsDateFilterKey = "IntegrationsDateFilter"; //key which maps to the user preference value

const Integrations = () => {
  const dispatch = useDispatch();
  const tabValue = useSelector(selectTabSelectionsIntegration);
  const setTabValue = (value) => dispatch(setTabSelectionsIntegration(value));

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);

    // heap.io

    const tabDict = {};

    tabDict[0] = "Connections";
    tabDict[1] = "Endpoints";
    tabDict[2] = "File Manager";

    const tabLabel = tabDict[newValue];

    if (tabLabel !== undefined) {
      window.heap.track(`Integrations - Select ${tabLabel} Tab`);
    }
  };

  const { startDate, endDate, source } =
    useSelector(selectIntegrationDateFilter) || {};
  const [dates, setDates] = useState([startDate, endDate]);

  // Load preferred start date once
  useEffect(() => {
    dispatch(
      loadDateFilter({
        area: "integration",
        preferenceKey: integrationsDateFilterKey,
      }),
    );
  }, [dispatch]);

  // Sync local dates for the date picker when redux updates
  useEffect(() => {
    if (startDate && endDate) {
      setDates([startDate, endDate]);
    }
  }, [startDate, endDate]);

  const setDateFilterFromDate = (startDate, endDate) => {
    if (startDate == null || endDate == null) return;
    dispatch(
      setIntegrationDateFilter({
        startDate: startDate,
        endDate: endDate,
        source: source ? source : "user",
      }),
    );
  };
  //useCallback persists the debounced function
  const debouncedSetDateFilter = useCallback(
    _.debounce(setDateFilterFromDate, 1000),
    [],
  );
  useEffect(() => {
    //delay when making first date selection
    debouncedSetDateFilter(dates[0], dates[1]);
  }, [dates[0]]);
  useEffect(() => {
    //cancel delay and trigger backend call immediately (flush) after second date selection
    debouncedSetDateFilter(dates[0], dates[1]);
    debouncedSetDateFilter.flush();
  }, [dates[1]]);
  return (
    <Container sx={{ backgroundColor: "var(--disabled)" }}>
      <Container
        sx={{
          position: "sticky",
          top: "0",
          zIndex: "1400",
        }}
      >
        <MainNavigation selected={MenuItemEnum.Integrations} />
      </Container>
      <Container className="content-container">
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            borderBottom: "1.5px solid var(--primary-main)",
            marginBottom: "0px",
          }}
        >
          <ShepTabs
            sx={{
              margin: "1px 30px 0px 0",
              //  borderBottom: "1px solid var(--primary-main)",
            }}
            variant="primary"
            value={tabValue}
            onChange={handleTabChange}
          >
            <ShepTab
              variant="primary"
              key="1"
              label={"Connections"}
              id="tab-0"
              aria-controls="tabpanel-0"
              sx={{ width: "310px" }}
            />
            <ShepTab
              variant="primary"
              key="2"
              id="tab-1"
              aria-controls="tabpanel-1"
              label={"Endpoints"}
              iconPosition="start"
            />
            <ShepTab
              variant="primary"
              key="3"
              label={"File Manager"}
              id="tab-2"
              aria-controls="tabpanel-2"
              iconPosition="start"
            />
            <ShepTab
              variant="primary"
              key="4"
              label={"Email Manager"}
              id="tab-3"
              aria-controls="tabpanel-3"
              iconPosition="start"
            />
          </ShepTabs>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "flex-end",
              flex: 1,
              marginTop: "auto",
              marginBottom: "5px",
            }}
          >
            <Stack direction="column">
              <CustomDatePicker
                dates={dates}
                setDates={setDates}
                onApply={() => {}}
                heapIOParentPage={tabValue === 2 ? "File Manager" : null}
                preferenceKey={integrationsDateFilterKey}
              />
            </Stack>
          </div>
        </div>
        <Box
          className="content-box"
          sx={{ display: "flex", flexDirection: "row" }}
        >
          {tabValue === 0 && <ConnectionHome />}
          {tabValue === 1 && <EndpointHome />}
          {tabValue === 2 && <FileManager />}
          {tabValue === 3 && <EmailManager />}
        </Box>
      </Container>
    </Container>
  );
};

export default Integrations;
